import React from 'react';
import { BarChart3, FileText, Download, Calendar, Users, Truck } from 'lucide-react';

const Rapports = () => {
  const rapports = [
    {
      id: 1,
      titre: 'Rapport mensuel - Janvier 2024',
      date: '2024-02-01',
      type: 'Mensuel',
      livraisons: 56,
      clients: 12,
      exportUrl: '#'
    },
    {
      id: 2,
      titre: 'Rapport douane - Janvier 2024',
      date: '2024-02-01',
      type: 'Douane',
      livraisons: 8,
      clients: 5,
      exportUrl: '#'
    },
    {
      id: 3,
      titre: 'Rapport activité - Semaine 2',
      date: '2024-01-14',
      type: 'Hebdomadaire',
      livraisons: 14,
      clients: 7,
      exportUrl: '#'
    }
  ];

  return (
    <div className="space-y-6">
      {/* En-tête */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-port-gray-900">Rapports</h1>
          <p className="text-port-gray-600">Aperçu et export des rapports de livraisons</p>
        </div>
        <button className="btn-primary flex items-center space-x-2">
          <BarChart3 className="h-5 w-5" />
          <span>Exporter tout</span>
        </button>
      </div>

      {/* Liste des rapports */}
      <div className="card p-6">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-port-gray-200">
            <thead className="bg-port-gray-50">
              <tr>
                <th className="table-header px-6 py-3 text-left">Titre</th>
                <th className="table-header px-6 py-3 text-left">Date</th>
                <th className="table-header px-6 py-3 text-left">Type</th>
                <th className="table-header px-6 py-3 text-left">Livraisons</th>
                <th className="table-header px-6 py-3 text-left">Clients</th>
                <th className="table-header px-6 py-3 text-left">Export</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-port-gray-200">
              {rapports.map((rapport) => (
                <tr key={rapport.id} className="table-row">
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      <FileText className="h-5 w-5 text-atl-blue-600 mr-2" />
                      <span className="font-medium text-port-gray-900">{rapport.titre}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      <Calendar className="h-4 w-4 text-port-gray-400 mr-2" />
                      <span className="text-port-gray-900">{rapport.date}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className="text-port-gray-900">{rapport.type}</span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      <Truck className="h-4 w-4 text-port-gray-400 mr-2" />
                      <span className="text-port-gray-900">{rapport.livraisons}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      <Users className="h-4 w-4 text-port-gray-400 mr-2" />
                      <span className="text-port-gray-900">{rapport.clients}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <a href={rapport.exportUrl} className="btn-success flex items-center space-x-2">
                      <Download className="h-4 w-4" />
                      <span>Exporter</span>
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Rapports; 